module.exports = __webpack_public_path__ + "img/jigouruzhu-1.e77c03bc.svg";